import React from "react";
import styleClasses from "../../../../containers/order/order.module.scss";
import { ILabels } from "../../../../models/card";

const Labels: React.FC<ILabels> = (props) => {
  const {
    isItSubstitute,
    priceAlternateLabel,
    additionalPrice = 0,
    calories,
    price,
    remainingBase,
    showAdditionalPrice = false,
    count = 0,
    itemBase = 0,
    isCreateYourOwnItem,
  } = props;

  const showPriceAdjustment = () => {
    if (price && price > 0) {
      return `+$${price.toFixed(2)}`;
    } else {
      return isItSubstitute ? "Substitute" : "";
    }
  };


  const ExtraPrice = () => {
    if (remainingBase > 0) {
      if (price <= remainingBase) {
        return 0;
      } else if (price - remainingBase > 0) {
        return price - remainingBase;
      }
    } else {
      return price;
    }
  };

  return (
    <h6
      className={`${styleClasses.item_detals} f-s10 font-rale d-flex justify-content-between mb-0 lh-normal text-nowrap`}
    >
      {calories > 0 && `${calories} cal`}

      {!isCreateYourOwnItem && additionalPrice > 0 && (
        <span className="text-danger font-Visby-cf f-w5 w-100 text-end" data-testid="counterCardPrice">
          +${additionalPrice.toFixed(2)}
        </span>
      )}
    </h6>
  );
};

export default Labels;
